(() => {
  const storageKey = '4thrive-color-mode';

  function setTheme(mode) {
    const nextMode = mode === 'light' ? 'light' : 'dark';
    document.documentElement.dataset.sssTheme = nextMode;
    try {
      window.localStorage.setItem(storageKey, nextMode);
    } catch (_) {}

    document.querySelectorAll('[data-sss-password-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', nextMode === 'light' ? 'true' : 'false');
    });
  }

  function initialize() {
    document.querySelectorAll('[data-sss-password-theme-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        setTheme(document.documentElement.dataset.sssTheme === 'light' ? 'dark' : 'light');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
